
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import styled from "styled-components";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Spinner} from "../../components/SpinnerRaw/SpinnerRaw";

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  onClose?: React.MouseEventHandler<HTMLImageElement | HTMLButtonElement>;
  disableData: any;
  loader?: Boolean;  
  previousPaymentId: any;
  accountId: any;
}

const DisableAutopay = ({ onClose, disableData,loader,previousPaymentId, accountId}: Props) => {
  //   useEffect(()=>{
  //     General.sendOTP({errorId: 'sendOTPError', data: {premiseId:null, email, mobile, personID}})
  //   },[])

  return (
    <div style={{ width:General?.isLargeScreen? "50%":'100%', overflow: "auto", margin: "30vh auto" ,direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",}}>
      <div
        style={{
          width: "100%",
          justifyContent: "space-between",
          padding:'1rem',
          background:  General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General.ColorAss,
          display: "flex",
          alignItems: "center",
        }}
      >
        <h1  style={{ color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff", justifySelf: "flex-start",fontSize:`${2*General.accessibility.fontSize}rem` }}>
        {General?.codeLabels["cm_disable_autopay"]?.label !== undefined ? General?.codeLabels["cm_disable_autopay"]?.label :"DISABLE AUTOPAY"}
        </h1>
      </div>
<TabContainer style={{
          padding: "3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}>

   {General?.codeLabels["cm_autopay_disable_confirmation"]?.label !== undefined ? General?.codeLabels["cm_autopay_disable_confirmation"]?.label : "Are You Sure You Want To Disable Autopay?"}
</TabContainer>

      <TabContainer
        style={{
          padding: "0.3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}
      >

        <ButtonsContainer
          style={{ display: "flex", gap: "12px", width: "fit-content", paddingBottom: "1rem" }}
        >
          <ButtonSecondary
            style={{ 
              width: "45%", 
              padding: "auto",
              fontSize:`${General.accessibility.fontSize}rem`,
              color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              background: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "white",
              borderColor: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
            }}
            onClick={onClose}
          >
            {General?.codeLabels["cm_usepassloginpagecancel"]?.label !== undefined ? General?.codeLabels["cm_usepassloginpagecancel"]?.label : "CANCEL"}

          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground:"#fff",
              background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor :General?.ColorAss,
              border:"none",
              whiteSpace: "nowrap",fontSize:`${General.accessibility.fontSize}rem`
            }}
            onClick={() =>disableData({ previousPaymentId, accountId })}
          >
            {loader?    <Spinner width="30px" height="30px"/>:General?.codeLabels["cm_btncontinue"]?.label !== undefined ? General?.codeLabels["cm_btncontinue"]?.label : "CONTINUE"}
         </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
    </div>
  );
};

export default observer(DisableAutopay);
